<template>
    <div class="space-y-3">
        <section class="space-y-1">
            <form-label>Entity of {{ plateName || 'the selected plate' }}</form-label>
            <GpioEntitySelector :model-value="node.data.entity" :entities="entities"
                @update:model-value="entity => logic.updateNodeData(page, node.id, { entity })" />
            <p v-if="entity" class="text-xs text-gray-300">
                {{ entity.domain }}<span v-if="entity.name"> · {{ entity.name }}</span>
            </p>
            <p v-else-if="!entities.length" class="text-xs text-gray-400">
                No GPIO metadata for this plate yet; you can still enter an entity ID.
            </p>
        </section>

        <section class="space-y-1">
            <form-label>Events</form-label>
            <p v-if="!events.length" class="text-xs text-gray-300">
                Add an Event from the palette while this node is selected, or drag a wire from its output.
            </p>
            <button v-for="item in events" :key="item.node.id" type="button"
                class="flex w-full items-center justify-between gap-2 rounded border border-white/20 bg-white/5 px-1.5 py-0.5 text-left text-xs hover:border-ui-active"
                @click="logic.select(page, 'node', item.node.id)">
                <span class="truncate">⚡ {{ item.node.data.event || '(no event selected)' }}</span>
                <span class="shrink-0 text-gray-300">{{ item.actions }} action{{ item.actions === 1 ? '' : 's' }}</span>
            </button>
        </section>

        <p class="text-[11px] leading-tight text-amber-300">
            GPIO events run their actions once the firmware supports GPIO input actions;
            the export lists them as <code>gpio_actions</code> on this page.
        </p>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useLogicStore } from '../../stores/logicStore.js';
import { getEventActionWires, getEventNodesForSource } from '../../logic/logicGraph.js';
import GpioEntitySelector from '../gpio/GpioEntitySelector.vue';

const props = defineProps({
    page: { type: Object, required: true },
    graph: { type: Object, required: true },
    node: { type: Object, required: true },
    entities: { type: Array, default: () => [] },
    plateName: { type: String, default: '' },
});
const logic = useLogicStore();

const entity = computed(() => props.entities.find(item => item.id === props.node.data.entity) ?? null);
const events = computed(() => getEventNodesForSource(props.graph, { node: props.node.id, port: 'events' })
    .map(node => ({ node, actions: getEventActionWires(props.graph, node.id).length })));
</script>
